import React, { useContext } from 'react'
import HeaderProfile from './HeaderProfile'
import { FaBars } from 'react-icons/fa'
import { FiChevronRight, FiGlobe, FiHome } from 'react-icons/fi'
import { MainMenuActiveContext } from '../context/MainMenuActiveContext'
import { MainLanguageContext } from '../context/MainLanguageContext'
import { Link, useLocation } from 'react-router-dom'

const Header = () => {
  const { handlelanguage,mainLanguage } = useContext(MainLanguageContext);
    const { handleGetEditValue } = useContext(MainMenuActiveContext);
    const { pathname } = useLocation();
    const segments = pathname.split('/').filter(Boolean);


  return (
    <header className='header'>
      <div className="header__left">
        <button type="button" className='mobileMenuButton' aria-label="Open navigation" onClick={() => handleGetEditValue(true)}>
          <FaBars aria-hidden="true" />
        </button>
        <nav className="shellBreadcrumb" aria-label="Breadcrumb">
          <Link to="/" aria-label="Dashboard"><FiHome /></Link>
          {segments.map((segment, index) => <React.Fragment key={`${segment}-${index}`}><FiChevronRight /><span>{/^\d+$/.test(segment) ? `#${segment}` : segment.replaceAll('-', ' ')}</span></React.Fragment>)}
        </nav>
      </div>
      <div className="header__right flex items-center gap-4">
        <div className="languageSelect">
        <FiGlobe aria-hidden="true" />
        <select aria-label="Language" value={mainLanguage} onChange={(e) => handlelanguage(e.target.value)}>
                <option value="en">English</option>
                <option value="ar">Arabic</option>
                {/* <option value="ru">Russian</option>
                <option value="ch">Chinese</option> */}
            </select>
        </div>
        <div className='profile flex items-center gap-4'>
          <HeaderProfile />
        </div>
      </div>
      {/* close header__right  */}
    </header>
  )
}

export default Header
